import { DateTime } from 'luxon'

import { CoreAPI } from '@/api/core/CoreAPI'
import { City } from '@/model/City'
import { Snapshot } from '@/model/Snapshot'
import { ISnapshotService } from '@/services/snapshot/ISnapshotService'
import { BaseService } from '../BaseService'
import { ServiceLocator } from '../ServiceLocator'
import { SnapshotValueFactory } from './SnapshotValueFactory'
import { TimeStepValue } from '@/model/TimeStepValue'
import { TimeStepCumulativeRainfall } from '@/model/TimeStepCumulativeRainfall'
import { SnapshotCumulativeRainfallFactory } from './SnapshotCumulativeRainfallFactory'

export class SnapshotService extends BaseService implements ISnapshotService {
  private readonly api: CoreAPI = new CoreAPI()

  constructor(serviceLocator: ServiceLocator) {
    super(serviceLocator)
  }
  async loadCumulativeRainfallSnapshot(
    city: City,
    timestamp: DateTime,
  ): Promise<Snapshot<TimeStepCumulativeRainfall>> {
    let dto = null
    try {
      dto = await this.api.getCumulativeRainfallSnapshot(city.getName(), timestamp)
    } catch (exception) {
      console.error(exception)
    }
    return dto
      ? SnapshotCumulativeRainfallFactory.fromDTO(dto, city)
      : SnapshotCumulativeRainfallFactory.createEmpty(city, timestamp)
  }

  async loadValueSnapshot(city: City, timestamp: DateTime): Promise<Snapshot<TimeStepValue>> {
    let dto = null
    try {
      dto = await this.api.getValueSnapshot(city.getName(), timestamp)
    } catch (exception) {
      console.error(exception)
    }
    return dto ? SnapshotValueFactory.fromDTO(dto, city) : SnapshotValueFactory.createEmpty(city, timestamp)
  }
}
